
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import resumen from './resumen/resumen.vue';
    import items from './items/items.vue';
    import facturacion from './facturacion/facturacion.vue';
    import pagos from './pagos/pagos.vue';
    import editar_cliente from './editar-cliente/editar.vue';
    import editar_envio from './editar-envio/editar.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            resumen,
            pagos,
            facturacion,
            items,
            editar_cliente,
            editar_envio,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public get Vista() { return this.Controlador.Vista; }

        async mounted()
        {
            await this.Controlador.Iniciar( Number( this.$route.params.id ) );
            this.Refrescar();
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public Refresh: boolean = false;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
